import { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { useClientNode, useMount } from 'hooks';

interface Input {
    duration: number;
    isCollapsed: boolean;
}

interface Output {
    isAnimating: boolean;
    nodeRef: (el: HTMLElement | null) => void;
}

export default function useCollapse({ duration, isCollapsed }: Input): Output {
    const [isAnimating, setIsAnimating] = useState<boolean>(false);
    const [node, nodeRef] = useClientNode();

    const mount = useRef<boolean>(false);
    const durationRef = useRef<number>(duration);
    durationRef.current = duration;

    useEffect(() => {
        node?.parentElement?.style.setProperty(
            `--Collapse-height`,
            `${node.clientHeight}px`
        );
        node?.parentElement?.style.setProperty(
            `--Collapse-duration`,
            `${durationRef.current}ms`
        );
    }, [node]);

    useMount(() => {
        mount.current = true;
    });

    useLayoutEffect(() => {
        if (!mount.current) return;

        setIsAnimating(true);

        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, durationRef.current);

        return () => clearTimeout(timer);
    }, [isCollapsed]);

    return {
        isAnimating,
        nodeRef,
    };
}
